import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";

interface ISiteDescriptionSubSectionProps {
    localizedDescription: LocalizedTextDto;
}

function SiteDescriptionSubSection(props: ISiteDescriptionSubSectionProps): JSX.Element {
    const { localizedDescription } = props;

    return (
        <>
            <div className="view-subsection-header row">
                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                    <h4 className="view-subsection-title">{cacheStore.GetString("ClinicInfo_SiteDescriptionLabel")}</h4>
                </div>
            </div>

            <div className="view-subsection-body">
                {AdministrationHelper.getLocalizedTextSiteViewArray(localizedDescription).map((item, index) => (
                    <div key={`siteDescription_${index}`} className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{item.languageName}</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <strong>{item.value}</strong>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export { ISiteDescriptionSubSectionProps };
export default SiteDescriptionSubSection;
